import useCourseFilter from './useCourseFilter';

export default useCourseFilter;
